const fan = {
  license: {
    LicenseAgent: '許可證清單',
		onLineActivate: '線上啟動',
		offLineActivate: '離線啟動',
		plan: '計劃',
		SerialNumberList: '啟動碼',
		ExpirationTime: '過期時間',
    EffictiveTime: '生效時間',
		viewClientID: '查看HWID',
		Description: '描述',
		deactivate: '停用',
		sortFile: '拖拽檔案至此處或者手動選擇',
		selectFile: '選擇檔案',
		DelteteTip: '您確定要停用該許可證嗎？',
    Status: '狀態',
    MicroFrameManage: '集群管理',
    License: '許可證',
    Service: '服務',
    LicenseList: '許可證列表',
    Name: '名稱',
    CustomerName: '自訂名稱',
    Service: '服務',
    HWID: 'HWID',
    SerialNumberList: '啟動碼',
    Active_Deactive: '活動/停用',
    Action: '操作',
    AddLicense: '添加許可證',
    required: '必填',
    Permanent: '永久',
    Customname: '自訂名稱',
    Delete: '刪除',
    Detail: '詳情',
    BindedService: '綁定服務',
    nodata: '暂无数据'
  },
  service: {
    ServiceList: '服務清單',
    Name: '名稱',
    Version: '版本',
    Checksum: 'Checksum',
    Description: '描述',
    Action: '操作',
    VersionHistory: '版本歷史',
    required: '必填',
    Delete: '刪除',
    DeleteTip: '您確定要刪除',
    AddService: '添加服務',
    EditService: '編輯服務',
    Plan: '計畫'
  }
}

export default fan


// WEBPACK FOOTER //
// ./src/js/i18n/fan.js